import { useState } from "react";

export function useSorting(
  initialField = "id",
  initialOrder: "ASC" | "DESC" = "ASC"
) {
  const [sorting, setSorting] = useState([
    { id: initialField, desc: initialOrder.toUpperCase() === "DESC" },
  ]);

  return {
    sorting,
    onSortingChange: setSorting,
    order: !sorting.length ? initialOrder : sorting[0].desc ? "DESC" : "ASC",
    field: sorting.length ? sorting[0].id : initialField,
    fieldWithOrder: sorting
      .map((sort) => `${sort.id} ${sort.desc ? "DESC" : "ASC"}`)
      .join(","),
  };
}
